import {common_utils} from "../common/common_utils";

function game_3002()
{

}


game_3002.getWinInfo = function(obj)
{
  let winInfo = "";
  if(common_utils.isNull(obj))
  {
    return winInfo;
  }
  let TotalBet = 0;
  let TotalWin = 0;
  let JumpHeight  = 0;
  if(obj.TotalBet)
  {
    TotalBet = obj.TotalBet;
  }
  if(obj.JumpHeight){
    JumpHeight = obj.JumpHeight;
  }
  if(obj.TotalWin)
  {
    TotalWin = obj.TotalWin;
  }
  winInfo += "("+ (TotalBet / 100).toFixed(2)+" x " +JumpHeight+")"+" - " +(TotalBet / 100).toFixed(2);
  winInfo += " = " +(TotalWin / 100).toFixed(2)+" - " +(TotalBet / 100).toFixed(2);
  winInfo += " = " +((TotalWin-TotalBet) / 100).toFixed(2);
  return winInfo;
}

export {
  game_3002
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3002.js